

























import { defineComponent } from "@vue/composition-api";
import { StoryTip } from "@scrile/api-provider/dist/api/StoriesProvider";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import InfiniteScroll from "@/components/InfiniteScroll";
import StoryStatisticTipItem from "../StoryStatisticTipItem";

export default defineComponent({
  name: "StoryStatisticTipsList",
  components: { StoryStatisticTipItem, CustomScroll, InfiniteScroll, BaseSpinner },
  props: {
    items: { type: Array as () => StoryTip[], required: true },
    total: { type: Number, required: true },
    enableScroll: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
  },
});
